var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 29 29.2 7.8l2.8 2.8-21.2 21.2L8 29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11 8 21.2 21.2-2.8 2.8L8.2 10.8 11 8Z"
  })));
};
export default SvgCross;